import { ReactNode } from 'react'

import Footer from '@/components/footer'
import Header from '@/components/navigation'

interface Props {
  children: ReactNode
}

const LayoutWithNavigation = ({ children }: Props) => (
  <>
    <main className="font-natosans flex flex-col min-h-screen">
      <section className="max-w-7xl m-auto w-full">
        <Header />
      </section>
      <div className="flex-1">{children}</div>
      <Footer />
    </main>
  </>
)

export default LayoutWithNavigation
